import styled from "styled-components/macro"
import { useStore } from "@state/store"
import { poundFormatter } from "@utils/functions"

const ResidenceInfoCard = ({ unit }) => {
  const contentControls = useStore((s) => s.contentControls)
  if (!unit || contentControls.index === null) return null
  const selectedUnit = unit[0]

  return (
    <Wrapper id="residenceInfoCard">
      <div className="specsContainer">
        <div className="spec-top">
          {<div>{BEDKEY[selectedUnit?.beds]}</div>}
          {selectedUnit?.typology === "Apartment" && (
            <>
              <div>|</div>
              <div>
                {selectedUnit?.floor === "0"
                  ? "Ground Floor"
                  : `Floor ${selectedUnit?.floor}`}
              </div>
            </>
          )}
        </div>
        <div className="UnitID">
          <div>{selectedUnit?.id}</div>
          <h3>
            {selectedUnit?.["address_1"]?.toLowerCase()}{" "}
            {selectedUnit?.["address_2"]?.toLowerCase()}{" "}
            {selectedUnit?.typology === "Apartment" && <br />}
            <span>{selectedUnit?.["address_3"]?.toLowerCase()}</span>{" "}
            {selectedUnit?.postcode}
          </h3>
        </div>

        <div className="spec">
          <div>Availability</div>
          <div className="spec2">{selectedUnit?.status}</div>
        </div>
        <div className="spec">
          <div>Price</div>
          <div className="spec2">
            {poundFormatter.format(selectedUnit?.price)}
          </div>
        </div>
        <div className="spec">
          <div>Management Charges</div>
          <div className="spec2">
            {poundFormatter.format(selectedUnit?.["service_charge"])}
          </div>
        </div>
        <div className="spec">
          <div>Lease</div>
          <div className="spec2">{selectedUnit?.["lease_length"]}</div>
        </div>
      </div>
      <div className="specsContainer">
        <div className="spec">
          <div>Bedrooms</div>
          <div className="spec2">{BEDKEY[selectedUnit?.beds]}</div>
        </div>
        <div className="spec">
          <div>Area</div>
          <div className="spec2">{selectedUnit?.area} sqft.</div>
        </div>
        {/* <div className="spec">
          <div>Aspect</div>
          <div className="spec2">{selectedUnit?.aspect}</div>
        </div> */}
      </div>
      <div className="eco-info">
        <ul>
          <h2>Sustainable Credentials</h2>
          <li>100% low-energy lighting throughout dwellings.</li>
          <li>
            Superior levels of insulation which exceeds government standards.
          </li>
          <li>
            Each dwelling is achieving circa 40% CO2 reductions against
            regulations.
          </li>
          <li>
            Energy efficient mechanical ventilation systems to create an
            improved internal environment for occupants.
          </li>
          <li>
            Each dwelling is served by a low- carbon heating source (ASHP).
          </li>
        </ul>
      </div>
      <div className="eco-info">
        <ul>
          <h2>Security and peace of mind</h2>
          <li>Video door entry system – to apartments.</li>
          <li>Lifts – to apartment floors.</li>
          <li>Smoke detectors/fire alarms.</li>
          <li>Sprinklers installed to all apartments.</li>
          <li>999 year lease.</li>
          <li>10 year building warranty from completion.</li>
        </ul>
      </div>
    </Wrapper>
  )
}

export default ResidenceInfoCard

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-right: 1px solid rgba(0, 0, 0, 0.5);
  padding: 0 5em;

  .UnitID {
    display: flex;
    flex-direction: column;
    font-size: 5rem;
    font-weight: 400;
    margin-bottom: 4rem;

    & h3 {
      font-size: 2rem;
      color: var(--secondary);
      letter-spacing: 3px;
      text-transform: capitalize;
    }
  }

  .specsContainer {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 2rem;

    .spec {
      width: 100%;
      display: flex;
      gap: 1rem;
      font-size: 1rem;

      & div:nth-of-type(1) {
        text-transform: uppercase;
        letter-spacing: 2px;
        font-family: ThirdFont;
        color: var(--black);
        opacity: 1;
      }
    }
    .spec-top {
      width: 100%;
      display: flex;
      gap: 1rem;
      font-size: 1.2rem;
      font-family: ThirdFont;
    }
  }
  .spec2 {
    margin-left: auto;
    letter-spacing: 2px;
    font-size: 1.3rem;
    text-transform: capitalize;
  }

  .eco-info {
    padding-left: 0;
    width: 100%;
    & ul {
      padding-left: 2rem;
      list-style: none;

      & h2 {
        font-family: ThirdFont-regular;
        margin: 1rem 0;
      }

      & li {
        opacity: 0.5;
        margin: 8px 0;
        font-family: ThirdFont;
        font-size: 1rem;
      }
    }
  }
`

export const BEDKEY = {
  3: "Three Beds",
  2: "Two Beds",
  1: "One Bed",
  0: "Studio",
}
